<mat-spinner [diameter]="diameter" [strokeWidth]='strokeWidth'></mat-spinner>